(function () {
    'use strict';

    a3_cabin_reports.factory('JeppesenFlightDetailsFactory', JeppesenFlightDetailsFactory)

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name JeppesenFlightDetailsFactory
    * @description 
    *   Departure info panel (STD, TOBT, etc).
    * @ngInject
    */
    function JeppesenFlightDetailsFactory(GenericService, $http, $q, LogService, apiUrl, FlightFactory) {
        var objType = 'JeppesenFlightDetails';
        var objCallback = JeppesenDetails;

        var objectTypeHistory = 'CTOTChangeHistory';
        var objCallbackHistory = CtotHistoryEntry;

        function JeppesenDetails() {
            this.flightId = null;
            this.jeppesenData = {};
            this.showDepartureInfoModal = false;
            this.GetId = GetId;
        }

        function CtotHistoryEntry() {
            this.flightId = null;
            this.ctotHistory = [];
            this.GetId = GetId;
        }

        var service = {
            getJeppesenDetailsFromStorage: getJeppesenDetailsFromStorage,
            setJeppesenFlightDetailsToStorage: setJeppesenFlightDetailsToStorage,
            getAllJeppesenDetailsFromStorage: getAllJeppesenDetailsFromStorage,
            setAllToStorage: setAllToStorage,
            getCtotHistoryFromStorage: getCtotHistoryFromStorage,
            setCtotHistoryToStorage: setCtotHistoryToStorage,
            getAllCtotHistoriesFromStorage: getAllCtotHistoriesFromStorage,

            // Common
            setToStorage: setToStorage,
            cleanOldData: cleanOldData,

            // Departure info
            getDepartureDetails: getDepartureDetails,
        };

        /**
        * Overide default get Id
        * @memberof JeppesenFlightDetailsFactory
        * @returns {number} Id 
        */
        function GetId() {
            return this.flightId;
        }

        /**
        * Retrieves Jeppesen details for a specific flight from local storage
        */
        function getJeppesenDetailsFromStorage(flightId) {
            return GenericService.get(flightId, objType, objCallback);
        }

        /**
         * Saves new Jeppesen data to local storage for a flight
         */
        function setJeppesenFlightDetailsToStorage(flightId, details) {
            if (!flightId || !details) return;

            var item = getJeppesenDetailsFromStorage(flightId) || new JeppesenDetails();
            item.flightId = flightId;
            item.jeppesenData = details;

            setToStorage(item, objType, objCallback);
        }

        /**
         * Retrieves all Jeppesen details from local storage    
         * @returns {Array} Array of JeppesenDetails objects
         */
        function getAllJeppesenDetailsFromStorage() {
            var all = GenericService.list(objType, objCallback);
            var items = [];
            for (var i = 0; i < all.length; i++) {
                if (all[i]) {
                    items.push(all[i]);
                }
            }
            return items;
        }

        /**   
         * Retrieves all CTOT history entries from local storage
         * @returns {Array} Array of CtotHistoryEntry objects
         */
        function setAllToStorage(list) {
            GenericService.saveAll(list, objType);
        }

        /**         
         * Retrieves all CTOT history entries from local storage
         * @returns {Array} Array of CtotHistoryEntry objects
         */
        function getCtotHistoryFromStorage(flightId) {
            var record = GenericService.get(flightId, objectTypeHistory, objCallbackHistory);
            return record && record.ctotHistory ? record.ctotHistory : [];
        }

        /**         
         * Retrieves all CTOT history entries from local storage
         * @returns {Array} Array of CtotHistoryEntry objects                       
         */
        function setCtotHistoryToStorage(flightId, historyArray) {
            if (!flightId || !Array.isArray(historyArray)) return;

            var item = GenericService.get(flightId, objectTypeHistory, objCallbackHistory) || new CtotHistoryEntry();
            item.flightId = flightId;
            item.ctotHistory = historyArray;

            setToStorage(item, objectTypeHistory, objCallbackHistory);
        }

        /**
         * Retrieves all CTOT history entries from local storage
         * @returns {Array} Array of CtotHistoryEntry objects
         */
        function getAllCtotHistoriesFromStorage() {
            var all = GenericService.list(objectTypeHistory, objCallbackHistory);
            var items = [];
            for (var i = 0; i < all.length; i++) {
                if (all[i]) {
                    items.push(all[i]);
                }
            }
            return items;
        }

        /**
         * Saves an object to local storage
         * Adds or updates based on existing entry
         */
        function setToStorage(obj, type, callback) {
            if (!obj) return;
            if (GenericService.get(obj.flightId, type, callback)) {
                GenericService.save(obj, type, callback);
            } else {
                GenericService.add(obj, type, callback);
            }
        }

        /**
         * Removes all entries from storage except for valid flightIds (cleanup)
         */
        function cleanOldData(validFlightIds) {
            if (!Array.isArray(validFlightIds)) return;

            var allDetails = getAllJeppesenDetailsFromStorage();
            var filtered = allDetails.filter(x => validFlightIds.includes(x.flightId));
            setAllToStorage(filtered);
        }

        /**
         * Fetches departure details for a flight from the API and updates local storage  
         * @returns {Promise} A promise that resolves with the response data
         * */  
        function getDepartureDetails(flightId, flightNo, flightDate, departure) {
			var call = $q.defer();
            var flightDateStr =  flightDate.toString('yyyy-MM-dd');	

            $http.get(apiUrl + '/info/DepartureDetails?flightId=' + flightId + 
                                                     '&flightNo=' + flightNo +
                                                     '&flightDate=' + flightDateStr +
                                                     '&departure=' + departure, 
                     { 'Content-Type': 'application/json' })
				.then(
					function (responseData) {
						if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined) {
							var err = new Error();
							err.status = -1;
							var msg = "ResponseData error on get departure details :" + JSON.stringify(responseData);
							LogService.debug(msg, err)
							call.reject(err);
							return;
						}
                        var jeppesenDetails = responseData.data.data.jeppesenFlightDetails;
                        if (jeppesenDetails) {
                            setJeppesenFlightDetailsToStorage(flightId, jeppesenDetails);
                        }
                        var ctotHistory = responseData.data.data.ctotHistory;
                        if (Array.isArray(ctotHistory) && ctotHistory.length > 0) {
                            setCtotHistoryToStorage(flightId, ctotHistory);
                        }
                        var flightDetailsSync = responseData.data.data.flightTimeDeparture;
                        // update flight departure details
                        if(flightDetailsSync){
                            var flightForLS = FlightFactory.getFlightFromStorage(flightId);
                            var updateTheFlight = false;
                            if(flightForLS){
                                 if(flightForLS.ScheduledDeparture != flightDetailsSync.STD){
                                    flightForLS.ScheduledDeparture = flightDetailsSync.STD;
                                    updateTheFlight = true;
                                }
                                if(flightForLS.ETD != flightDetailsSync.ETD){
                                    flightForLS.ETD = flightDetailsSync.ETD;
                                    updateTheFlight = true;
                                }
                                if(flightForLS.ATD != flightDetailsSync.ATD){
                                    flightForLS.ATD = flightDetailsSync.ATD;
                                    updateTheFlight = true;
                                }
                            }
                            if(updateTheFlight){
                                FlightFactory.updateFlight(flightForLS);
                            }
                        }

						call.resolve(responseData);
					},
					function (err) {
						call.reject(err);
					}
				);
			return call.promise;
		}


        return service;
    }
})();